import React from "react";
import "./App.scss";
import MainRoute from "./routes/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import ReactGA from "react-ga4";
import { GA_TRACKING_ID } from "./config/constant";
function App() {
  // Initialize Google Analytics
  ReactGA.initialize(GA_TRACKING_ID);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        theme="colored"
        autoClose={3000} // ✅ Explicit instead of default
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      <MainRoute />
    </div>
  );
}

export default App;
